/**
 * sophior-b2b-order.js
 * Bestellogica voor de zakelijke bestellijst (sections/sophior-b2b-bestellijst.liquid).
 * - Aantal-steppers die de B2B quantity rules (min/max/bestelvoud) respecteren
 * - Rijtotalen en het totaalbedrag, inclusief staffelprijzen (quantity_price_breaks)
 * - Alles in één keer toevoegen via /cart/add.js, daarna de native drawer openen
 *   via de bestaande events uit assets/sophior-cart-sync.js.
 * - /cart/add.js is bij een batch NIET atomisch: bij een 422 kan een deel van de
 *   regels al (deels) zijn toegevoegd. Daarom wordt de cart vóór en na de POST
 *   gelezen en worden de invoervelden gereconcilieerd, zodat een tweede klik
 *   nooit al-toegevoegde regels dupliceert.
 */
(function () {
  var root = document.querySelector('[data-b2b-list]');
  if (!root) return;

  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-row]'));
  var submitBtn = root.querySelector('[data-b2b-submit]');
  var countEl = root.querySelector('[data-b2b-count]');
  var totalEl = root.querySelector('[data-b2b-total]');
  var suffixEl = root.querySelector('[data-b2b-total-suffix]');
  var totalExEl = root.querySelector('[data-b2b-total-ex]');
  var totalExWrap = root.querySelector('[data-b2b-total-ex-wrap]');
  var statusEl = root.querySelector('[data-b2b-status]');
  var overviewToggle = root.querySelector('[data-b2b-overview-toggle]');
  var overviewPanel = root.querySelector('[data-b2b-overview]');
  var overviewList = root.querySelector('[data-b2b-overview-list]');
  if (!submitBtn || rows.length === 0) return;

  /* Getoonde prijzen zijn incl. btw; excl = incl * 100 / (100 + btw%).
     parseFloat: de btw-setting mag decimalen bevatten en moet exact de
     Liquid-berekening volgen */
  var btwDeler = parseFloat(root.dataset.btwDeler) || 121;
  function exBtw(cents) {
    return Math.round(cents * 100 / btwDeler);
  }

  var labels = {
    adding: root.dataset.addingLabel || 'Toevoegen...',
    addedTemplate: root.dataset.addedTemplate || '[aantal] producten toegevoegd aan je winkelwagen.',
    addedSingle: root.dataset.addedTemplateSingle || '1 product toegevoegd aan je winkelwagen.',
    errorFallback: root.dataset.errorFallback || 'Toevoegen is niet gelukt, probeer het opnieuw.',
    summaryTemplate: root.dataset.summaryTemplate || '[aantal] stuks geselecteerd',
    summarySingle: root.dataset.summaryTemplateSingle || '1 stuk geselecteerd',
    emptySummary: countEl ? countEl.textContent : ''
  };
  var submitLabel = submitBtn.textContent;
  var bezig = false;

  /* Zelfde format als het shop-moneyformat (€{{amount_with_comma_separator}}):
     geen spatie na het euroteken, komma-decimaal, punt-duizendtal. Conventie
     gedeeld met sophior-addon-bundle.js en sophior-sticky-atc.js. */
  function formatMoney(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + euros.replace(/\B(?=(\d{3})+(?=,))/g, '.');
  }

  function rowState(row) {
    if (!row._b2b) {
      var breaks = [];
      if (row.dataset.breaks) {
        try { breaks = JSON.parse(row.dataset.breaks); } catch (e) { breaks = []; }
        breaks.sort(function (a, b) { return a[0] - b[0]; });
      }
      row._b2b = {
        input: row.querySelector('[data-b2b-qty]'),
        knoppen: Array.prototype.slice.call(row.querySelectorAll('.sophior-b2b__stepper-knop')),
        totalCell: row.querySelector('[data-b2b-row-total]'),
        unitCell: row.querySelector('[data-b2b-unit-price]'),
        unitCellEx: row.querySelector('[data-b2b-unit-price-ex]'),
        id: parseInt(row.dataset.variantId, 10),
        price: parseInt(row.dataset.price, 10) || 0,
        min: parseInt(row.dataset.min, 10) || 1,
        step: parseInt(row.dataset.step, 10) || 1,
        max: row.dataset.max ? parseInt(row.dataset.max, 10) : null,
        breaks: breaks,
        basePriceText: null,
        basePriceExText: null
      };
      if (row._b2b.unitCell) row._b2b.basePriceText = row._b2b.unitCell.textContent;
      if (row._b2b.unitCellEx) row._b2b.basePriceExText = row._b2b.unitCellEx.textContent;
    }
    return row._b2b;
  }

  function readQty(row) {
    var s = rowState(row);
    var v = parseInt(s.input.value, 10);
    return isNaN(v) || v < 0 ? 0 : v;
  }

  /* Snap een ingevoerd aantal naar de dichtstbijzijnde geldige waarde volgens
     de quantity rule: 0, of min + n*bestelvoud, begrensd op max. */
  function snapQty(row, qty, richtingOmhoog) {
    var s = rowState(row);
    if (qty <= 0) return 0;
    if (qty < s.min) return richtingOmhoog === false ? 0 : s.min;
    var stappen = Math.round((qty - s.min) / s.step);
    if (richtingOmhoog === true) stappen = Math.ceil((qty - s.min) / s.step);
    var geldig = s.min + stappen * s.step;
    if (s.max !== null && geldig > s.max) {
      geldig = s.min + Math.floor((s.max - s.min) / s.step) * s.step;
    }
    return geldig;
  }

  function unitPrice(row, qty) {
    var s = rowState(row);
    var prijs = s.price;
    for (var i = 0; i < s.breaks.length; i++) {
      if (qty >= s.breaks[i][0]) prijs = s.breaks[i][1];
    }
    return prijs;
  }

  function updateRow(row) {
    var s = rowState(row);
    var qty = readQty(row);
    if (s.totalCell) {
      s.totalCell.textContent = qty > 0 ? formatMoney(unitPrice(row, qty) * qty) : '–';
    }
    /* Bij staffels de actuele stukprijs tonen zodra die verandert (incl. én excl.) */
    if (s.breaks.length > 0) {
      if (s.unitCell) {
        s.unitCell.textContent = qty > 0 ? formatMoney(unitPrice(row, qty)) : s.basePriceText;
      }
      if (s.unitCellEx) {
        s.unitCellEx.textContent = qty > 0 ? formatMoney(exBtw(unitPrice(row, qty))) : s.basePriceExText;
      }
    }
  }

  /* ---- Uitklapbaar selectie-overzicht in de sticky balk ----
     Aantal stuks per product, zodat de klant de invoer in één oogopslag
     kan naleggen tegen zijn eigen bestellijst. */
  var overviewOpen = false;
  var skuPrefix = root.dataset.skuPrefix || 'Art.nr.';

  function renderOverview() {
    if (!overviewList) return;
    overviewList.textContent = '';
    rows.forEach(function (row) {
      var qty = readQty(row);
      if (qty === 0) return;
      var s = rowState(row);

      var li = document.createElement('li');
      li.className = 'sophior-b2b__overzicht-item';

      var qtyEl = document.createElement('span');
      qtyEl.className = 'sophior-b2b__overzicht-aantal';
      qtyEl.textContent = qty + ' ×';
      li.appendChild(qtyEl);

      var productEl = document.createElement('span');
      productEl.className = 'sophior-b2b__overzicht-product';
      var naamEl = document.createElement('span');
      naamEl.className = 'sophior-b2b__overzicht-naam';
      naamEl.textContent = row.dataset.name || '';
      productEl.appendChild(naamEl);
      if (row.dataset.sku) {
        var skuEl = document.createElement('span');
        skuEl.className = 'sophior-b2b__overzicht-sku';
        skuEl.textContent = skuPrefix + ' ' + row.dataset.sku;
        productEl.appendChild(skuEl);
      }
      li.appendChild(productEl);

      var totaalEl = document.createElement('span');
      totaalEl.className = 'sophior-b2b__overzicht-totaal';
      /* Zelfde afronding als de balk: excl. per stuk afronden, dan maal aantal */
      totaalEl.textContent = formatMoney(exBtw(unitPrice(row, qty)) * qty);
      li.appendChild(totaalEl);

      overviewList.appendChild(li);
    });
  }

  function setOverviewOpen(open) {
    overviewOpen = open;
    if (overviewPanel) overviewPanel.hidden = !open;
    if (overviewToggle) overviewToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) renderOverview();
  }

  if (overviewToggle) {
    overviewToggle.addEventListener('click', function () {
      setOverviewOpen(!overviewOpen);
      /* Het paneel staat in de DOM vóór de knop: focus verplaatsen zodat
         screenreaders de zojuist geopende lijst direct vooruit kunnen lezen */
      if (overviewOpen && overviewPanel) {
        overviewPanel.focus({ preventScroll: true });
      }
    });
  }

  function updateSummary() {
    var stuks = 0;
    var totaal = 0;
    var totaalEx = 0;
    rows.forEach(function (row) {
      var qty = readQty(row);
      if (qty > 0) {
        stuks += qty;
        totaal += unitPrice(row, qty) * qty;
        /* Zelfde afronding als de excl.-kolom: per stuk afronden, dan maal aantal */
        totaalEx += exBtw(unitPrice(row, qty)) * qty;
      }
    });
    if (overviewToggle) overviewToggle.hidden = stuks === 0;
    if (stuks === 0) {
      if (overviewOpen) setOverviewOpen(false);
    } else if (overviewOpen) {
      /* Open overzicht live meebewegen met elke wijziging in de aantallen */
      renderOverview();
    }
    if (countEl) {
      if (stuks === 0) {
        countEl.textContent = labels.emptySummary;
      } else if (stuks === 1) {
        countEl.textContent = labels.summarySingle;
      } else {
        countEl.textContent = labels.summaryTemplate.replace('[aantal]', stuks);
      }
    }
    if (totalEl) totalEl.textContent = stuks > 0 ? formatMoney(totaal) : '';
    if (suffixEl) suffixEl.hidden = stuks === 0;
    if (totalExEl) totalExEl.textContent = stuks > 0 ? formatMoney(totaalEx) : '';
    if (totalExWrap) totalExWrap.hidden = stuks === 0;
    submitBtn.disabled = bezig || stuks === 0;
  }

  function setBusy(busy) {
    rows.forEach(function (row) {
      var s = rowState(row);
      if (s.input) s.input.disabled = busy;
      s.knoppen.forEach(function (knop) { knop.disabled = busy; });
    });
  }

  function setStatus(tekst, isFout) {
    if (!statusEl) return;
    /* Regio blijft altijd in de DOM en accessibility tree (geen hidden):
       anders wordt de melding door screenreaders niet aangekondigd */
    statusEl.textContent = tekst;
    statusEl.classList.toggle('sophior-b2b__status--zichtbaar', !!tekst);
    statusEl.classList.toggle('sophior-b2b__status--fout', !!tekst && !!isFout);
  }

  /* Huidige cart-inhoud als map variant_id -> aantal (null bij een fout) */
  function cartMap() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return null;
        var map = {};
        cart.items.forEach(function (item) {
          map[item.variant_id] = (map[item.variant_id] || 0) + item.quantity;
        });
        return map;
      })
      .catch(function () { return null; });
  }

  rows.forEach(function (row) {
    var s = rowState(row);
    if (!s.input) return;

    s.input.addEventListener('input', function () {
      updateRow(row);
      updateSummary();
    });

    /* Pas bij verlaten van het veld naar een geldige waarde snappen,
       zodat we niet tegen het typen in vechten */
    s.input.addEventListener('change', function () {
      var geldig = snapQty(row, readQty(row));
      s.input.value = geldig > 0 ? geldig : '';
      updateRow(row);
      updateSummary();
    });

    var minus = row.querySelector('[data-b2b-minus]');
    var plus = row.querySelector('[data-b2b-plus]');
    if (minus) {
      minus.addEventListener('click', function () {
        var huidig = snapQty(row, readQty(row));
        var nieuw = huidig <= s.min ? 0 : snapQty(row, huidig - s.step, false);
        s.input.value = nieuw > 0 ? nieuw : '';
        updateRow(row);
        updateSummary();
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var huidig = snapQty(row, readQty(row));
        var nieuw = huidig === 0 ? s.min : snapQty(row, huidig + s.step, true);
        s.input.value = nieuw;
        updateRow(row);
        updateSummary();
      });
    }
  });

  submitBtn.addEventListener('click', function () {
    if (bezig) return;

    /* De gesubmitte rijen vastleggen: alleen díe worden na afloop geleegd of
       gereconcilieerd (invoer in andere rijen tijdens de request blijft staan) */
    var submitted = [];
    rows.forEach(function (row) {
      var qty = snapQty(row, readQty(row));
      var s = rowState(row);
      s.input.value = qty > 0 ? qty : '';
      updateRow(row);
      if (qty > 0) submitted.push({ row: row, state: s, qty: qty });
    });
    updateSummary();
    if (submitted.length === 0) return;

    bezig = true;
    setBusy(true);
    submitBtn.disabled = true;
    submitBtn.textContent = labels.adding;
    setStatus('');

    cartMap()
      .then(function (voor) {
        /* Zonder baseline geen reconciliatie-garantie bij een 422:
           dan liever helemaal niet posten */
        if (!voor) {
          setStatus(labels.errorFallback, true);
          return;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: submitted.map(function (sub) { return { id: sub.state.id, quantity: sub.qty }; })
          })
        })
          .then(function (r) {
            return r.json().then(function (data) { return { ok: r.ok, data: data }; });
          })
          .then(function (res) {
            if (!res.ok) {
              /* Shopify geeft bij 422 een leesbare message/description terug
                 (bijv. onvoldoende voorraad voor een regel). Een deel van de
                 regels kan dan al in de cart zitten: teller verversen en de
                 invoervelden terugbrengen tot wat er nog NIET in staat. */
              var msg = (res.data && (res.data.description || res.data.message)) || labels.errorFallback;
              setStatus(msg, true);
              document.dispatchEvent(new CustomEvent('sophior:cart-updated'));
              return cartMap().then(function (na) {
                if (!na) return;
                submitted.forEach(function (sub) {
                  var toegevoegd = (na[sub.state.id] || 0) - (voor[sub.state.id] || 0);
                  var rest = sub.qty - toegevoegd;
                  sub.state.input.value = rest > 0 ? snapQty(sub.row, rest) : '';
                  updateRow(sub.row);
                });
                updateSummary();
              });
            }
            submitted.forEach(function (sub) {
              sub.state.input.value = '';
              updateRow(sub.row);
            });
            updateSummary();
            setStatus(submitted.length === 1
              ? labels.addedSingle
              : labels.addedTemplate.replace('[aantal]', submitted.length));
            document.dispatchEvent(new CustomEvent('sophior:cart-updated'));
            document.dispatchEvent(new CustomEvent('sophior:open-cart'));
          });
      })
      .catch(function () {
        setStatus(labels.errorFallback, true);
      })
      .then(function () {
        bezig = false;
        setBusy(false);
        submitBtn.textContent = submitLabel;
        updateSummary();
        /* De disabled knop liet de toetsenbordfocus naar body vallen:
           herstellen naar de knop, of naar de statusmelding als de knop
           disabled blijft (lege selectie na succes) */
        if (document.activeElement === document.body) {
          if (!submitBtn.disabled) {
            submitBtn.focus();
          } else if (statusEl && statusEl.textContent) {
            statusEl.focus();
          }
        }
      });
  });

  function syncAll() {
    rows.forEach(updateRow);
    updateSummary();
  }

  syncAll();
  /* Browsers herstellen ingevulde formulierwaarden op verschillende momenten
     (Firefox tijdens het parsen, Chrome pas ná load) en vuren daarbij geen
     input-events: na pageshow alles opnieuw synchroniseren, plus één keer
     kort erna voor het late Chrome-herstel. */
  window.addEventListener('pageshow', function () {
    syncAll();
    window.setTimeout(syncAll, 150);
  });
})();
